import Modal from '../../common/Modal/Modal';
import './InProgressOverview.scss';
import { useEffect, useState } from 'react';
import MovementDetails from '../../common/MovementDetails/MovementDetails';
import MovementNotesPhotos from '../../common/MovementNotesPhotos/MovementNotesPhotos';
import CancelModal from '../InProgressJob/subComponents/CancelModal/CancelModal';
import PropTypes from 'prop-types';
import ConfirmModal from '../InProgressJob/subComponents/ConfirmModal/ConfirmModal';
import InProgressJob from '../InProgressJob/InProgressJob';
import UnexpectedJobModal from './subComponents/UnexpectedJobModal/UnexpectedJobModal';
import Packages from '../../api/controllers/Packages/Packages';
import JobLine from './subComponents/JobLine/JobLine';
import GoodsOut from '../../api/controllers/GoodsOut/GoodsOut';
import LoadUnexpectedModal from './subComponents/LoadUnexpectedModal/LoadUnexpectedModal';
import Button from '../../common/Button/Button';

// InProgressOverview Screen Component
const InProgressOverview = ({
  fromPending,
  movement,
  getMovement,
  qrResponse,
  setError,
  setLoading,
  movementType,
  category,
}) => {
  const [displayAssignment, setDisplayAssignment] = useState();
  const [damagePhoto, setDamagePhoto] = useState(false);
  const [packages, setPackages] = useState();

  const [modalOpen, setModalOpen] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const expectedAssignments = movement?.assignments?.filter(assignment => {
    if (movementType == 'exports') return assignment?.originHubId == hubId;
    else return assignment?.destinationHubId == hubId;
  });

  const notExpectedAssignments = movement?.assignments?.filter(assignment => {
    if (movementType == 'exports') return assignment?.originHubId != hubId;
    else return assignment?.destinationHubId != hubId;
  });

  const jobsWithPackages = Object.groupBy(packages || [], pkg => pkg?.job?.jobReference);
  const jobRefs = Object.keys(jobsWithPackages);
  const expectedRefs = movement?.assignments?.map(assignment => assignment?.job?.jobReference);
  const unexpectedExports = Object.keys(jobsWithPackages)
    .map(key => {
      if (!expectedRefs.includes(key)) {
        return { job: jobsWithPackages[key][0]?.job };
      }
    })
    .filter(element => {
      return element !== undefined;
    });

  const jobsToDisplay =
    movementType == 'imports'
      ? [
          ...expectedAssignments,
          ...notExpectedAssignments.filter(assignment =>
            jobRefs.some(jobRef => jobRef == assignment?.job?.jobReference),
          ),
        ]
      : [...expectedAssignments, ...unexpectedExports];

  const onScan = qrItem => {
    if (qrItem.category == 'package' && qrItem.id && movementType == 'exports') {
      if (packages?.find(item => item.id == qrItem.id)) {
        removePackage(qrItem.id);
      } else if (expectedAssignments?.find(assignment => assignment?.job?.id == qrItem?.jobId)) {
        assignPackage(qrItem.id);
      } else {
        setModalOpen({ type: 'load_unexpected', packageId: qrItem.id });
      }
    }
  };

  const assignPackage = pkgId => {
    setLoading(true);
    GoodsOut.assign(category, movement.id, pkgId)
      .then(() => {
        setLoading(false);
        getPackages();
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const removePackage = pkgId => {
    setLoading(true);
    GoodsOut.remove(category, movement.id, pkgId)
      .then(() => {
        setLoading(false);
        getPackages();
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getModalTitle = () => {
    switch (modalOpen.type) {
      case 'load_unexpected':
        return 'Confirm this package';
      case 'unload_unexpected':
        return 'Unload an unexpected job';
      case 'finish':
        return 'Confirm';
      default:
        return null;
    }
  };

  const getModalType = () => {
    switch (modalOpen.type) {
      case 'load_unexpected':
        return (
          <LoadUnexpectedModal
            packageId={modalOpen.packageId}
            category={category}
            movementId={movement?.id}
            setModalOpen={setModalOpen}
            refreshMovement={() => {
              getPackages();
            }}
          />
        );
      case 'unload_unexpected':
        return (
          <UnexpectedJobModal
            category={category}
            movementId={movement.id}
            movementType={movementType}
            setModalOpen={setModalOpen}
            assignments={notExpectedAssignments}
            refreshMovement={getPackages}
            setDisplayAssignment={setDisplayAssignment}
          />
        );
      case 'finish':
        return (
          <ConfirmModal
            category={category}
            id={movement.id}
            movementType={movementType}
            setModalOpen={setModalOpen}
            refreshMovement={getMovement}
            damaged={packages?.some(pkg => pkg?.damaged) || damagePhoto}
            packages={packages}
            expectedAssignments={expectedAssignments}
          />
        );
      case 'cancel':
        return (
          <CancelModal
            category={category}
            id={movement.id}
            movementType={movementType}
            setModalOpen={setModalOpen}
          />
        );
    }
  };

  const getPackages = () => {
    setLoading(true);
    const params =
      movementType == 'imports'
        ? { goodsInType: movement?.modelName, goodsInId: movement?.id }
        : { goodsOutType: movement?.modelName, goodsOutId: movement?.id };

    Packages.all(params)
      .then(response => {
        setLoading(false);
        setPackages(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    if (!displayAssignment) {
      getPackages();
    }
  }, [displayAssignment]);

  useEffect(() => {
    if (qrResponse) {
      onScan(qrResponse);
    }
  }, [qrResponse]);

  return (
    <div className="international_movement_container">
      {displayAssignment ? (
        <div className={`sliding-animation-container move-in`}>
          <div className="singular_job_container">
            <InProgressJob
              notExpected={notExpectedAssignments.find(
                assignment => assignment?.id == displayAssignment?.id,
              )}
              fromPending={fromPending}
              setDisplayAssignment={setDisplayAssignment}
              movement={movement}
              getMovement={getMovement}
              qrResponse={qrResponse}
              setLoading={setLoading}
              setError={setError}
              assignment={displayAssignment}
              movementType={movementType}
              category={category}
              allAssignedPackages={packages}
            />
          </div>
        </div>
      ) : (
        <div
          data-testid="in_progress_overview_container"
          className={`in_progress_overview_container ${
            displayAssignment == undefined ? '' : 'move-in'
          }`}
        >
          <MovementDetails movement={movement} category={'international'} />

          <div className="job_list_container">
            {jobsToDisplay?.map(assignment => (
              <JobLine
                movementType={movementType}
                key={assignment?.id}
                assignment={assignment}
                packages={jobsWithPackages[assignment?.job?.jobReference]}
                setDisplayAssignment={setDisplayAssignment}
                unexpected={
                  movementType == 'imports'
                    ? notExpectedAssignments.some(unexpected => unexpected.id == assignment?.id)
                    : unexpectedExports.some(
                        unexpected =>
                          unexpected?.job?.jobReference == assignment?.job?.jobReference,
                      )
                }
              />
            ))}
          </div>
          {movementType == 'imports' && (
            <div className="in_progress_movement_buttons unexpected">
              <Button
                buttonType="grey"
                className="in_progress_movement_button grey unexpected_job"
                onClick={() => setModalOpen({ type: 'unload_unexpected' })}
                label="Offload unexpected job"
              />
            </div>
          )}
          <MovementNotesPhotos
            setError={setError}
            movement={movement}
            movementType={movementType}
            setDamaged={setDamagePhoto}
          />
          <div className="in_progress_movement_buttons">
            <Button
              buttonType={'red'}
              className="in_progress_movement_button red cancel"
              onClick={() => setModalOpen({ type: 'cancel' })}
              label="Cancel"
            />

            <Button
              className={`in_progress_movement_button green finish_unloading ${
                packages?.length == 0 ? 'disabled' : ''
              }`}
              onClick={() => setModalOpen({ type: 'finish' })}
              disabled={packages?.length == 0}
              label={`Finish ${
                movementType == 'collections' || movementType == 'imports' ? 'Unl' : 'L'
              }oading`}
            />
          </div>
        </div>
      )}
      {modalOpen && (
        <Modal title={getModalTitle()} content={getModalType()} setModalOpen={setModalOpen} />
      )}
    </div>
  );
};

InProgressOverview.propTypes = {
  getMovement: PropTypes.func,
  fromPending: PropTypes.bool,
  movement: PropTypes.object,
  qrResponse: PropTypes.object,
  setError: PropTypes.func,
  setLoading: PropTypes.func,
  movementType: PropTypes.string,
  category: PropTypes.string,
};

export default InProgressOverview;
